const editLocation = {
  en: {
    translation: {
      seatings_title: "Number of seating",
      information_location_services: "Location info",
      description: "Description",
      description_language: "Language description",
      short_description: "Short description",
      add: "Add",
      parking: "Parking",
      isMultiFloor: "Is multi floor"
    }
  },
  it: {
    translation: {
      seatings_title: "Numero di coperti",
      information_location_services: "Informazioni sulla location",
      description: "Descrizione",
      description_language: "Descrizione in lingua",
      short_description: "Descrizione breve",
      add: "Aggiungi",
      parking: "Parcheggio",
      isMultiFloor: "Si sviluppa su più piani"
    }
  }
};

export default editLocation;
